import IUserUI from "@models/IUserUI";
import ISupplierModel from "@models/ISupplierModel";

// TODO: Temporary hardcoded override to unblock a specific user; replace with a supplier/user-level toggle.
const ACCOUNT_USERS_OVERRIDE_USER_GUID = "224aba48-ae2b-4f61-80d1-71a78edad553";
const ACCOUNT_USERS_OVERRIDE_SUPPLIER_GUID = "80744976-dbb8-4491-8238-6c7ef35801b1";

/**
 * Returns true when the current user should be allowed to create and edit
 * account users regardless of their user type or access type.
 */
export const hasAccountUsersOverride = (userModel: IUserUI, supplierModel: ISupplierModel): boolean => {
    return userModel.guid === ACCOUNT_USERS_OVERRIDE_USER_GUID && supplierModel.guid === ACCOUNT_USERS_OVERRIDE_SUPPLIER_GUID;
};
